/*
  单个集字的数据内容
*/

export default {
  state: {
    id: null,
    title: undefined,
    locked: true,
    vipsNeeded: [],
    creditsNeeded: null,
    cashNeeded: null
  },
  mutations: {
    UPDATE_FONT (state, font) {
      ['id', 'title', 'vipsNeeded', 'locked', 'creditsNeeded', 'cashNeeded'].forEach(key => {
        state[key] = font[key]
      })
    }
  },
  actions: {
    updateFont ({ commit }, font) {
      commit('UPDATE_FONT', font)
    }
  }
}
